import styled from 'styled-components'

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
`
export const Container = styled.div`
    display: flex;
    align-items: center;
    padding: 0 40px;
`

export const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 40px;
    gap: 16px;
    margin-top: 12px;
    margin-bottom: 40px;
`
